import maplibregl from "maplibre-gl";
import {
	addSoldPropertiesHoverEffects,
	onSoldPropertiesClick,
	soldPropertiesLayer,
} from "../layers/SoldPropertiesLayer.ts";
import { getSoldPropertiesSource, updateSoldPropertiesSource } from "./SoldPropertiesSource.ts";
import { getPostalCodePolygonSource } from "./PostalCodePolygonSource.ts";
import { postalCodePolygonFillLayer, postalCodePolygonLineLayer } from "../layers/PostalCodePolygonLayer.ts";
import { AppState } from "../AppState.ts";

export async function loadDataSourceFromState(map: maplibregl.Map) {
	const state = new AppState();

	if (state.dataSourceId === "sold-properties") {
		const soldPropertiesSource = await getSoldPropertiesSource(map);
		map.addSource("sold-properties-source", soldPropertiesSource);
		map.addLayer(soldPropertiesLayer);
		addSoldPropertiesHoverEffects(map);
		onSoldPropertiesClick(map, state);

		map.on("moveend", () => {
			updateSoldPropertiesSource(map);
		});
	}

	if (state.dataSourceId === "postal-code-polygon" && state.postalCode) {
		const postalCodePolygonSource = await getPostalCodePolygonSource();
		map.addSource("postal-code-polygon-source", postalCodePolygonSource);
		map.addLayer(postalCodePolygonFillLayer);
		map.addLayer(postalCodePolygonLineLayer);
	}
}
